function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.43235 11.7606L6.77428 6.53927C7.07524 6.24555 7.07524 5.75521 6.77428 5.46028L1.43235 0.240196C1.10473 -0.0800662 0.587543 -0.0800663 0.259929 0.240196C-0.0866422 0.579153 -0.0866423 1.14368 0.259929 1.48324L4.73396 5.85593C4.81512 5.93494 4.81512 6.06582 4.73396 6.14483L0.259928 10.5175C-0.0866431 10.8565 -0.0866432 11.421 0.259928 11.7606C0.424031 11.9198 0.634936 12 0.845841 12C1.05734 12 1.26824 11.9198 1.43235 11.7606Z",
  fill: "#595959"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.43235 11.7606L6.77428 6.53927C7.07524 6.24555 7.07524 5.75521 6.77428 5.46028L1.43235 0.240196C1.10473 -0.0800662 0.587543 -0.0800663 0.259929 0.240196C-0.0866422 0.579153 -0.0866423 1.14368 0.259929 1.48324L4.73396 5.85593C4.81512 5.93494 4.81512 6.06582 4.73396 6.14483L0.259928 10.5175C-0.0866431 10.8565 -0.0866432 11.421 0.259928 11.7606C0.424031 11.9198 0.634936 12 0.845841 12C1.05734 12 1.26824 11.9198 1.43235 11.7606Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_528_587)"
});

function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_528_587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 7,
    height: 12
  }, _ref3), _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forward-arrow.74e6acd8.svg";
export { ForwardRef as ReactComponent };